import React from 'react';
import { Drawer, Flex, Image, Link, IconButton, Portal } from '@chakra-ui/react';
import { XMarkIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { LuLogOut } from 'react-icons/lu';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';
import { NavigationContent } from './NavigationContent';
import { getNavigationForUser } from './navigationConfig';

interface MobileDrawerProps {
  open: boolean;
  onOpenChange: (details: { open: boolean }) => void;
}

export const MobileDrawer: React.FC<MobileDrawerProps> = ({ open, onOpenChange }) => {
  const { user, logout } = useAuth();

  if (!user) return null;

  const isAdmin = user.role === 'admin';
  const navigation = getNavigationForUser(isAdmin);

  const openHelp = () => window.open('https://aide.opentri.fr', '_blank', 'noreferrer,noopener');

  const handleClose = () => {
    onOpenChange({ open: false });
  };

  return (
    <Drawer.Root placement="start" open={open} onOpenChange={onOpenChange} size="full" lazyMount unmountOnExit>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content bg="#050e3a" color="white">
            <Drawer.Header>
              <Drawer.Title>
                <Flex justifyContent="space-between" alignItems="center">
                  <Link asChild>
                    <RouterLink to="/dashboard" onClick={handleClose}>
                      <Image src="/opentri-white.png" height={12} />
                    </RouterLink>
                  </Link>
                  <Drawer.CloseTrigger asChild colorPalette="white">
                    <IconButton
                      variant="plain"
                      colorPalette="white"
                      aria-label="Fermer le menu"
                    >
                      <XMarkIcon color="white" />
                    </IconButton>
                  </Drawer.CloseTrigger>
                </Flex>
              </Drawer.Title>
            </Drawer.Header>

            <Drawer.Body>
              <Flex direction="column" gap={4} pt={8}>
                <NavigationContent sections={navigation} onNavigate={handleClose} animateItems />
              </Flex>
            </Drawer.Body>

            <Drawer.Footer justifyContent="start">
              <Flex direction="column" gap={4}>
                <IconButton
                  variant="ghost"
                  bg="transparent"
                  color="white"
                  justifyContent="flex-start"
                  width="100%"
                  p={5}
                  onClick={openHelp}
                >
                  <QuestionMarkCircleIcon style={{ marginRight: '12px', width: '20px', height: '20px' }} />
                  Besoin d'aide ?
                </IconButton>

                <IconButton
                  variant="ghost"
                  bg="transparent"
                  color="white"
                  justifyContent="flex-start"
                  width="100%"
                  p={5}
                  onClick={() => {
                    logout();
                    handleClose();
                  }}
                >
                  <LuLogOut style={{ marginRight: '12px', width: '20px', height: '20px' }} />
                  Se déconnecter
                </IconButton>
              </Flex>
            </Drawer.Footer>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};
